import React, { useState } from 'react';
import { getLocalStorageItem, useOutsideClick } from '../../utils/helper';
import { Helmet } from 'react-helmet';
import Topbar from './Topbar';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { useNavigate } from 'react-router-dom';
import {
  errorToast,
  getPathForInstantSupport,
} from '../../utils/helper';
import CommonPopover from '../../component/common/popover';
import { CompanyApi } from '../../api/companyApi'; 
// Assuming the headphones image path is correct
import imgHeadphone from '../../assets/images/instantsupport-headphones.png';
import InfoPopup from '../../component/common/InfoPopup';

function InstantSupportLandingPage() {
  const { userType, companyId } = JSON.parse(localStorage.getItem('userData'));

  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));
  const [info, setInfo] = useState(null);

  const fetchInfo = async () => {
    if (userType === 4 || userType === 3) {
      try {
        const response = await CompanyApi.getInfoData('eap_b2b');
        if (response?.data?.meta?.code === 200) {
          if (response?.data?.data?.tutorialsData?.length > 0) {
            setOpen(true);
            setInfo(response?.data?.data);
          } else {
            setOpen(false);
            errorToast('Tutorial not found');
          }
        } else {
          setInfo(null);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  };

  return (
    <>
      <div className="relative lg:pl-5 lg:mb-[45px]">
        <Helmet>
          <meta charSet="utf-8" />
          <title>B2B | Instant Support</title>
        </Helmet>
        <Topbar title={'Instant Support'} infoBtn={true} setOpen={setOpen} fetchInfo={fetchInfo}/>

        <section className="relative flex bg-[#4A56DB] rounded-xl mt-9 w-full overflow-hidden">
          {/* Left side content */}
          <div className="flex flex-col px-3 py-3  text-white w-full sm:w-2/3 md:w-1/2">
            <h2 className="text-base md:text-xl font-medium">Instant Support</h2>
            <div className="w-full min-[1176px]:w-3/5">
              <p className="mt-3 text-[10px] min-[1176px]:text-xs mb-3 font-normal text-[#EDEEFC] max-w-md">
                Get instant support (EAP) for your team when they need it most. Connect with an
                expert and receive assistance today!
              </p>
            </div>

            <div className="flex flex-row mt-auto gap-3 items-center sm:items-start">
              <CommonPopover
                label={
                  <>
                    <span>Get support</span>
                    <ChevronDownIcon className="w-4 h-4 ml-1" />
                  </>
                }
                className="bg-white  text-[#4A56DB] text-[10px] min-[1176px]:text-[12px] px-3 sm:px-6 py-1 md:py-2 font-medium rounded-full flex items-center"
                contentClassName="w-29 ml-2 sm:ml-5 p-2 flex flex-col items-center"
              >
                <ul className="text-xs sm:text-base font-medium text-left w-24 sm:w-36 py-0 sm:py-2 ml-3 space-y-1">
                  <li>
                    <button
                      onClick={() => {
                        navigate(getPathForInstantSupport('/instant-support/get-support'));
                      }}
                    >
                      View Plans
                    </button>
                  </li>
                </ul>
                <ul className="text-xs sm:text-base font-medium text-left ml-3 w-24 sm:w-36 py-0 sm:py-2 pt-1 space-y-1 border-t mt-1">
                  <li>
                    <button onClick={() => {}}>Learn More</button>
                  </li>
                </ul>
              </CommonPopover>

              <button
                onClick={() =>
                  navigate(getPathForInstantSupport('/instant-support/add-custom-number'))
                }
                className="px-3 sm:px-4 py-1 md:py-2 text-[10px] min-[1176px]:text-[12px] text-white bg-transparent border border-white font-medium rounded-full sm:mt-0  w-auto"
              >
                Add custom number
              </button>
            </div>
          </div>

          {/* Right side - headphones images */}
          <div className="min-[1176px]:flex min-[1176px]:w-3/5 justify-end hidden">
            <img
              src={imgHeadphone}
              alt="Instant Support Headphones"
              className="max-w-full h-auto object-contain"
            />
          </div>
        </section>
        <InfoPopup
          open={open}
          data={info}
          title="Instant Support"
          handleClose={() => setOpen(false)}
        />
      </div>
    </>
  );
}

export default InstantSupportLandingPage;
